import React, { FC } from "react";
import { useToggleModal } from "../../../../lib/hooks/useToggleModal";
import { useWorkingHoursData } from "../../../Account/helpers/useWorkingHoursData";
import { tooltips } from "../../../../lib/utils/tooltips";

import { InfoCard } from "../../../shared/InfoCard/InfoCard";
import { WorkHours } from "./WorkHours/WorkHours";
import { ServiceEmail } from "./ServiceEmail/ServiceEmail";
import { BookingsSettings } from "./BookingsSettings/BookingsSettings";

type Props = {
  workingHoursDataQuery: ReturnType<typeof useWorkingHoursData>;
};

export const BookingAndNotificationsCard: FC<Props> = ({
  workingHoursDataQuery: {
    loading,
    error,
    customerSettings,
    handleWorkingHours,
  },
}) => {
  const workHoursToggleModal = useToggleModal();

  return (
    <InfoCard
      title="Booking & notifications"
      message={
        tooltips.organizationSettings.generalSettings.bookingsNotifications
      }
      direction="right"
    >
      <div className="OrganizationSettigs__cardContent OrganizationSettigs__workHours">
        <BookingsSettings
          loading={loading}
          error={error}
          handleDeskSimultaneous={handleWorkingHours}
          disableDeskSimultaneous={customerSettings?.disableDeskSimultaneous}
          deskBookingDisabledForRoles={
            customerSettings?.deskBookingDisabledForRoles
          }
          deskBookingEnabled={customerSettings?.deskBookingEnabled}
          roomBookingDisabledForRoles={
            customerSettings?.roomBookingDisabledForRoles
          }
          roomBookingEnabled={customerSettings?.roomBookingEnabled}
        />
        <WorkHours
          hasButton
          isOpen={workHoursToggleModal.isOpen}
          toggleModal={workHoursToggleModal.toggleModal}
          loading={loading}
          data={customerSettings}
          handleWorkingHours={handleWorkingHours}
        />
        <ServiceEmail
          errorReportingEmail={customerSettings?.errorReportingEmail}
          systemNotificationRecipientUserIds={
            customerSettings?.systemNotificationRecipientUserIds
          }
          handleEmailNotifications={handleWorkingHours}
          loading={loading}
          error={error}
        />
      </div>
    </InfoCard>
  );
};
